/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PasswordInputs */



/**
* | output |
* | --- |
* | "Password" |
*
* @param {Common_PasswordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_password = /** @type {((inputs?: Common_PasswordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PasswordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraseña")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Senha")
	if (locale === "it") return /** @type {LocalizedString} */ ("Password")
	return /** @type {LocalizedString} */ ("Password")
});